import React from 'react'
import './HeaderBanner.css'

const HeaderBanner: React.FC<any> = ({ media, title, description }) => {
  return (
    <div className="header-container">
      <div
        className="hero-image"
        style={{ backgroundImage: `url('${media}')` }}
      >
        <div className="header-content">
          <div className="foreground-container">
            <div className="hero-text">
              <div className="header-title">
                <span>{title}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderBanner
